import { createPortal } from "react-dom";
import cn from "classnames";
import { POPUP_CLASSNAME } from "constants/common.constants";
import { AppDOM } from "utils/app.utils";
import { ModalProps } from "./Modal.types";
import { Button, BUTTON_VARIANT } from "../Button";
import { Close } from "../Icons";
import s from "./Modal.module.scss";

function resolveModalContainer(): Element {
  const popup = AppDOM.querySelector(`.${POPUP_CLASSNAME}`);
  if (popup) return popup;

  if (AppDOM.appContainer) return AppDOM.appContainer;
  return document.body;
}

export const Modal = ({
  children,
  isOpen,
  onClose,
  closeButton = false,
  modalClassname,
  centered = false,
}: ModalProps) => {
  if (!isOpen) return null;

  const container = resolveModalContainer();

  return createPortal(
    <div className={cn(s.overlay, centered && s.overlayCentered)} onClick={onClose}>
      <div className={cn(s.modal, modalClassname)} onClick={(e) => e.stopPropagation()}>
        {children}

        {closeButton && (
          <Button className={s.btnClose} variant={BUTTON_VARIANT.ONLY_ICON_TRANSPARENT} onClick={onClose}>
            <Close />
          </Button>
        )}
      </div>
    </div>,
    container
  );
};
